import React from "react";
import { useTranslation } from "react-i18next";
import { IconChevronRight } from "@tabler/icons-react";
import { COLORS } from "@app/constants";
import { Text, View } from "@/styles/reactnative";
import { CButton } from "@app/components/Common";
import { Modal } from "antd";
import DWList from "../../../Header/DWList";
import { useTradeModalStore } from "../../../../hooks/trade/modalStore";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";
import styled from "styled-components";

const RecentDepositHeader = () => {
  const { t } = useTranslation();
  const [show, setShow] = React.useState(false);
  const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore();
  const isMobile = useIsMobile();

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        height: 50,
        paddingInline: 10,
        marginBottom: isMobile ? 20 : 0,
      }}
    >
      <Text
        size={14}
        style={{
          borderLeft: `2px solid  ${COLORS.primary}`,
          fontWeight: "600",
          paddingLeft: 10,
        }}
      >
        {t("recentDepositWithdrawalHistory")}
      </Text>

      <CButton
        title={t("all")}
        onClick={() => {
          setShow(true);

          mutateModalStore({
            ...modalStore,
            depositType: "*",
          });
        }}
        icon={<IconChevronRight size={14} style={{ color: COLORS.primary }} />}
        style={{
          color: COLORS.primary,
          fontSize: isMobile ? MobileCalVW(10) : undefined,
          cursor: "pointer",
        }}
      />
      <CustomModal
        width={1400}
        open={show}
        onOk={() => {
          setShow(false);
        }}
        onCancel={() => {
          setShow(false);
        }}
        className="custom-modal"
        centered
      >
        <DWList />
      </CustomModal>
    </View>
  );
};

export default RecentDepositHeader;

const CustomModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-card-head {
    padding: 0 10px;
  }

  .ant-card-body {
    padding: 10px 0;
  }

  .ant-modal-footer {
    display: none;
  }
`